import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import BookingDetail from "../Shared/BookingDetail";
import {
  getBookingDetails,
  clearBookingDetails,
} from "../../actions/commonActions";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../Shared/Loading";
import moment from "moment";

const BOOKING_DATE_FORMAT = "MMMM Do, dddd";
const BOOKING_DAY_FORMAT = "h:mm A";

export default function ({ showEventDetailsModal, eventDate, onClose }) {
  const dispatch = useDispatch();
  const { bookingDetails } = useSelector((reduxState) => reduxState.common);

  const [addresses, setAddresses] = useState([]);
const [loader,setLoader]=useState(false)
  useEffect(() => {
    getBookingDetails(dispatch, eventDate);
  }, []);

  useEffect(() => {
    if (bookingDetails && bookingDetails.length > 0) {
      const bookingAddresses = bookingDetails.map((bookingDetail) => {
        // replace - with / in date to make it compatable for safari
        // This line tells moment to consider it as UTC.
        const start_dt = bookingDetail.start_date_time
          ? moment.utc(bookingDetail.start_date_time.replace(/-/g, "/"))
          : "";
        // make this flag false somehow works in safari. Don't exactly know how??? todo for future.
        start_dt._isUTC = false;

        const end_dt = bookingDetail.end_date_time
          ? moment.utc(bookingDetail.end_date_time.replace(/-/g, "/"))
          : "";
        // make this flag false somehow works in safari. Don't exactly know how??? todo for future.
        end_dt._isUTC = false;

        return {
          country: bookingDetail.address.country
            ? bookingDetail.address.country.name
            : "",
          state: bookingDetail.address.state
            ? bookingDetail.address.state.name
            : "",
          city: bookingDetail.address.city
            ? bookingDetail.address.city.name
            : "",
          street_line_1: bookingDetail.address
            ? bookingDetail.address.street_line_1
            : "",
          street_line_2: bookingDetail.address
            ? bookingDetail.address.street_line_2
            : "",
          bundle_name: bookingDetail.bundle_name,
          visible_number: bookingDetail.visible_number,
          start_date_time: start_dt,
          end_date_time: end_dt,
        };
      });
      setAddresses(bookingAddresses);
    } else {
      setAddresses([]);
    }
  }, [bookingDetails]);

  const onModalClose = () => {
    clearBookingDetails(dispatch);
    setAddresses([]);
    onClose();
  };

  return (
    <div>
      <Modal show={showEventDetailsModal} onHide={onModalClose} centered>
        <Modal.Header>
          <h5 className="modal-title">Booking Details</h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={onModalClose}
          >
            &times;
          </button>
        </Modal.Header>
        <Modal.Body className="booking-details-modal">
          {addresses.length > 1&&!loader && (
            <span>* You have {addresses.length} Bookings.</span>
          )}
          {(bookingDetails && bookingDetails.length&&!loader > 0 ? (
            <div className="title-head text-center mb-lg-5 mb-4 parking-address">
              {addresses.map((address, i) => (
                <BookingDetail
                  key={i}
                  date={address.start_date_time}
                  className={"color-primary"}
                  dateFormat={BOOKING_DATE_FORMAT}
                  dayFormat={BOOKING_DAY_FORMAT}
                  address={address}
                  showBookingAddress={true}
                  parkingSlotBookingID={bookingDetails[i]?.parking_slot_booking_id}
                  eventDate={eventDate}
                  setLoader={setLoader}

                />
              ))}
            </div>
          ) :bookingDetails.length===0?
       <div style={{textAlign:"center"}}>Not Found</div>   
              
              :
              <div className="row justify-content-center align-items-center">
                <Loading />
              </div>
            )}
        </Modal.Body>
      </Modal>
    </div>
  );
}
